import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  HotelModel,
  HotelMutationInput,
  HotelDeleteInput,
  HotelUpdateInput,
} from './model';

export function useCreateHotel(
  options?: UseMutationOptions<
    ApiResult<HotelModel>,
    ApiError,
    HotelMutationInput
  >,
): UseMutationResult<ApiResult<HotelModel>, ApiError, HotelMutationInput> {
  return useMutation<ApiResult<HotelModel>, ApiError, HotelMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: 'hotels',
        method: 'POST',
        classType: HotelModel,
        body,
      });
    },
    options,
  );
}

export function useUpdateHotel(
  options?: UseMutationOptions<
    ApiResult<HotelModel>,
    ApiError,
    HotelUpdateInput
  >,
): UseMutationResult<ApiResult<HotelModel>, ApiError, HotelUpdateInput> {
  return useMutation<ApiResult<HotelModel>, ApiError, HotelUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `hotels/${body.hotelId}`,
        method: 'PUT',
        classType: HotelModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useDeleteHotel(
  options?: UseMutationOptions<{ message: string }, ApiError, HotelDeleteInput>,
): UseMutationResult<{ message: string }, ApiError, HotelDeleteInput> {
  return useMutation<{ message: string }, ApiError, HotelDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `hotels/${body.hotelId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}
